var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';

var BooleanViewer = function BooleanViewer(_ref) {
  var _ref$field = _ref.field,
      field = _ref$field === undefined ? {} : _ref$field,
      value = _ref.value,
      _ref$as = _ref.as,
      T = _ref$as === undefined ? 'span' : _ref$as,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      props = _objectWithoutProperties(_ref, ['field', 'value', 'as', 'className']);

  if (value) {
    return React.createElement(T, _extends({}, props, { className: 'boolean-true  fa fa-check-square-o ' + className }));
  } else {
    return React.createElement(T, _extends({}, props, { className: 'boolean-false fa fa-square-o ' + className }));
  }
};
export { BooleanViewer };